import { SendInvoiceAsEmailPayload } from '../../query-api'
import { SendAsEmailForm } from '../../types/sendAsEmailForm'

interface GetSendInvoiceAsEmailPayloadOptions {
  acceptStripePayment?: boolean
  captchaToken: string
  formData: SendAsEmailForm
  organizationEmail?: string
}

export const getSendInvoiceAsEmailPayload = ({
  acceptStripePayment = false,
  captchaToken,
  formData,
  organizationEmail,
}: GetSendInvoiceAsEmailPayloadOptions): SendInvoiceAsEmailPayload => {
  const payload = {
    ...(formData?.shouldSendCopyToMyself &&
      organizationEmail && {
        bcc: organizationEmail,
      }),
    acceptStripePayment,
    ...(!!formData?.attachmentUuids?.length && { attachmentUuids: formData.attachmentUuids }),
    captchaToken,
    cc: formData?.ccEmailRecipients?.join(', '),
    body: formData?.emailMessage?.trim().replace(/\n/g, '<br />'),
    subject: formData.emailSubject,
    to: formData.emailRecipients.join(', '),
  }

  return payload
}
